import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Tabs, Events } from 'ionic-angular';
import { PedidosPage } from '../pedidos/pedidos';
import { ClientesPage } from '../clientes/clientes';
import { DashboardPage } from '../dashboard/dashboard';
import { HomePage } from '../home/home';

/**
 * Generated class for the Tabs2Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tabs2',
  templateUrl: 'tabs2.html',
})
export class Tabs2Page {
  tab1Root = DashboardPage;
  tab2Root = ClientesPage;
  tab3Root = PedidosPage;
  tab4Root = HomePage;
  @ViewChild('myTabs') tabRef: Tabs;
  super: any = true
  loading: any = true
  constructor(public navCtrl: NavController, public navParams: NavParams, public events: Events) {
  }

  ionViewDidLoad() {
    if (this.navParams.get('value') === "Dashboard") {
      this.tabRef.select(0)
    } else if (this.navParams.get('value') === "Clientes") {
      this.tabRef.select(1)
    } else if (this.navParams.get('value') === "Pedidos") {
      this.tabRef.select(2)
    } else if (this.navParams.get('value') === "Articulos") {
      this.tabRef.select(3)
    }
  }

  onTabsChange() {
    // Get the previous tab if any
    const previousTab = this.tabRef.previousTab(false);

    if(previousTab) {
      try {
        // Get the navCtrl and pop to the root page
        previousTab.getViews()[0].getNav().popToRoot();
      } catch(exception) {
        // Oops...
        console.error(exception);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs2/tabs2.ts